import React, { useEffect } from "react";
import { Drawer, Form, Row, Col, Button, Input } from "antd";
import { useTranslation } from "react-i18next";

import Api from "../../../api";

import "../../../public/sass/components/drawer/_createDrawers.scss";
import { toastNotification } from "../../../utils/toastNotification";

const EditSupport = ({ isVisible, onClose, handleGetAllWebPages, data }) => {
  const [form] = Form.useForm();
  const [t, i18n] = useTranslation();

  const handleSubmit = (formValues) => {
    Api("web-pages/" + data.id, "PATCH", formValues)
      .then(() => {
        toastNotification("success", "Support successfully edited");
        handleGetAllWebPages();
        onClose();
      })
      .catch((err) => {
        toastNotification("error", err.error || "Error while editing support");
      });
  };

  useEffect(() => {
    if (isVisible) {
      let response = { ...data };
      return form.setFieldsValue(response);
    }
  }, [isVisible]);

  return (
    <Drawer
      title={t("edit_website")}
      width={720}
      onClose={onClose}
      visible={isVisible}
      className="body-style"
      destroyOnClose={true}
      footer={
        <div className="footer-style">
          <Button onClick={onClose} className="button-style">
            {t("cancel")}
          </Button>
          <Button
            type="primary"
            form="edit-support-form"
            key="submit"
            htmlType="submit"
          >
            {t("submit")}
          </Button>
        </div>
      }
    >
      <Form
        form={form}
        id="edit-support-form"
        layout="vertical"
        scrollToFirstError
        onFinish={handleSubmit}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="title"
              label={t("title")}
              rules={[{ required: true, message: `${t("title")}` }]}
            >
              <Input placeholder={t("title")} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="link"
              label={t("Website")}
              rules={[{ required: true, message: `${t("Website")}` }]}
            >
              <Input placeholder={t("Website")} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Drawer>
  );
};
export default EditSupport;
